import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=d23fc6f4&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=d23fc6f4&scoped=true&lang=css&"
import style1 from "./index-phone.css?vue&type=style&index=1&id=d23fc6f4&scoped=true&lang=css&"
import style2 from "./loading-box.css?vue&type=style&index=2&id=d23fc6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23fc6f4",
  null
  
)

export default component.exports